import { defineComponent as _defineComponent } from 'vue'
import { vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import SogPage from "@/shared/ui/SogPage.vue";
import {computed, onMounted, reactive, ref, watch} from "vue";
import {
  onBeforeRouteUpdate,
  RouteLocationNormalizedLoaded,
  useRoute,
  useRouter,
} from "vue-router";
import { OrgStructureCluster } from "@/shared/model/orgStructureCluster";
import PersonList from "@/modules/OrganisationStructure/components/PersonListComponent.vue";
import SogCardContent from "@/shared/ui/SogCardContent.vue";
import SogCard from "@/shared/ui/SogCard.vue";
import Person from "@/shared/model/person";
import apiOrganisationStructure from "@/modules/OrganisationStructure/api";
import SogCardActions from "@/shared/ui/SogCardActions.vue";
import SogCardActionButton from "@/shared/ui/SogCardActionButton.vue";
import { useAccountStore } from "@/stores/accountStore";
import { useNavigationStore } from "@/modules/Navigation/store";
import SogTextBox from "@/shared/ui/SogTextBox.vue";
import { SogButtonKind } from "@/shared/ui/types/SogButtonKind";
import { useOrganisationStructureStore } from "@/modules/OrganisationStructure/store";
import { storeToRefs } from "pinia";
import { useSpinner } from "@/shared/composables/SogSpinner";


export default /*@__PURE__*/_defineComponent({
  __name: 'OrganisationStructureListPage',
  setup(__props) {

const _router = useRouter();

const _list = ref<InstanceType<typeof PersonList> | null>(null);

const _title = ref("");

const _data: Person[] = reactive([]);
const _all = ref<Person[] | undefined>([]);

const _type = ref<OrgStructureCluster>(OrgStructureCluster.All);
const _level = ref("first");

//const _addVisible = ref(false);

const _navigationStore = useNavigationStore();
const _organisationStructureStore = useOrganisationStructureStore();
const _accountStore = useAccountStore();

const _selectedId = ref<string | undefined>(undefined);

const {
  listPage: _listPage,
  createPage: _createPage,
  detailsPage: _detailsPage,
} = storeToRefs(_organisationStructureStore);
const _spinner = useSpinner();

async function p_init(route: RouteLocationNormalizedLoaded) {
  const type = route.params.type as OrgStructureCluster;
  const level = route.params.level as string;

  _level.value = level === "" ? "first" : level;
  _type.value = type;

  if (_level.value !== "first" && !_navigationStore.currentPersonId) {
    await _router.push("/organisationstructure/list/" + type);
    return;
  }

  switch (type) {
    case OrgStructureCluster.Customer:
      _title.value = "Kunden";
      break;
    case OrgStructureCluster.Branch:
      _title.value = "Filialen";
      break;
    case OrgStructureCluster.BranchTemplate:
      _title.value = "Vorlagefiliale";
      break;
    case OrgStructureCluster.Employee:
      _title.value =
        "Mitarbeitern" +
        (level === "second"
          ? " von " + _listPage.value.secondCurrentPersonName
          : "");
      break;
    case OrgStructureCluster.Supplier:
      _title.value = "Lieferanten";
      break;
    case OrgStructureCluster.Manufacturer:
      _title.value = "Versicherer/Hersteller";
      break;
    case OrgStructureCluster.LossAdjuster:
      _title.value = "Schadenregulierer";
      break;
    case OrgStructureCluster.All:
      _title.value = "Alle";
      break;
    default:
      _title.value = type;
  }
  _spinner?.show();

  const t_ownerPersonId =
    _level.value === "second"
      ? _listPage.value.secondCurrentPersonId
      : _accountStore.person?.id;
  _all.value = await apiOrganisationStructure.list(t_ownerPersonId ?? "", type);

  search();

  _selectedId.value = undefined;
  _spinner?.hide();
}

onMounted(async () => {
  const route = useRoute();
  await p_init(route);
});

onBeforeRouteUpdate(async (to) => {
  await p_init(to);
});

async function onAdd() {
  if (_level.value === "second") {
    _createPage.value.ownerPersonId =
      _listPage.value.secondCurrentPersonId ?? "";
    _createPage.value.ownerPersonName =
      _listPage.value.secondCurrentPersonName ?? "";
  } else {
    _createPage.value.ownerPersonId = _accountStore.person?.id ?? "";
    _createPage.value.ownerPersonName = _accountStore.person?.personName ?? "";
  }
  await _router.push(
    "/organisationstructure/add/" + _type.value + "/" + _level.value
  );
}

/*
watch(_type, () => {
  _addVisible.value =
      _type.value !== OrgStructureCluster.LossAdjuster &&
      _type.value !== OrgStructureCluster.Manufacturer &&
      _type.value !== OrgStructureCluster.Supplier &&
      _type.value !== OrgStructureCluster.All
  _addVisible.value = _addVisible.value ||  (_type.value === OrgStructureCluster.BranchTemplate )&&_all.value!=undefined && _all.value.length===0;
});
*/

const _addVisible = computed(() => {
  if(_type.value === OrgStructureCluster.BranchTemplate)
    return _all.value===undefined || _all.value.length===0;

  return _type.value !== OrgStructureCluster.LossAdjuster &&
  _type.value !== OrgStructureCluster.Manufacturer &&
  _type.value !== OrgStructureCluster.Supplier &&
  _type.value !== OrgStructureCluster.All

})

function on(person?: Person) {
  _selectedId.value = person?.id;
  _navigationStore.currentPersonId = _selectedId.value ?? "";
  _navigationStore.currentPersonName = person?.personName;
}

async function onInfo() {
  if (
    _navigationStore.currentPersonId &&
    _navigationStore.currentPersonId !== "unknown"
  ) {
    _detailsPage.value.ownerPersonId = _listPage.value.secondCurrentPersonId;
    await _router.push("/organisationstructure/details/" + _level.value);
  }
}

function search() {
  _data.length = 0;
  //_all.value?.filter(t=>t.id!=="unknown"&&t.personName?.toLowerCase().includes(_name.value.toLowerCase())).map(t=>_data.push(t))
  _all.value
    ?.filter(
      (t) =>
        t.id !== "unknown" &&
        t.personName
          ?.toLowerCase()
          .includes(_listPage.value.search.toLowerCase())
    )
    .map((t) => _data.push(t));
  _list.value?.refresh();
}

function onBack() {
  if (_level.value === "second") {
    _navigationStore.currentPersonId = _listPage.value.secondCurrentPersonId;
    _navigationStore.currentPersonName =
      _listPage.value.secondCurrentPersonName;
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SogPage, {
    id: "page",
    title: _title.value
  }, {
    default: _withCtx(() => [
      _createVNode(SogCard, null, {
        default: _withCtx(() => [
          _createVNode(SogCardActions, null, {
            default: _withCtx(() => [
              _withDirectives(_createVNode(SogCardActionButton, {
                "mdi-icon": "mdi-account-plus",
                onClick: onAdd
              }, null, 512), [
                [_vShow, _addVisible.value]
              ]),
              _withDirectives(_createVNode(SogCardActionButton, {
                "mdi-icon": "mdi-information",
                disabled: !_selectedId.value,
                onClick: onInfo
              }, null, 8, ["disabled"]), [
                [_vShow, _selectedId.value]
              ]),
              _createVNode(SogTextBox, {
                modelValue: _unref(_listPage).search,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(_listPage).search) = $event)),
                placeholder: "Name",
                "interval-modified": search
              }, null, 8, ["modelValue"]),
              _createVNode(SogCardActionButton, {
                style: {"align-self":"flex-end"},
                kind: _unref(SogButtonKind).Search,
                onClick: search
              }, null, 8, ["kind"]),
              _createVNode(SogCardActionButton, {
                style: {"align-self":"flex-end"},
                kind: _unref(SogButtonKind).Back,
                onClick: onBack
              }, null, 8, ["kind"])
            ]),
            _: 1
          }),
          _createVNode(SogCardContent, null, {
            default: _withCtx(() => [
              _createVNode(PersonList, {
                ref_key: "_list",
                ref: _list,
                data: _data,
                selected: on
              }, null, 8, ["data"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})